<template>
    <v-dialog v-model="dialog" width="800px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">{{ title }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-4">
                <v-row>
                    <v-col cols="12" class="pt-6">
                        <v-textarea v-model="org_text" :rows="6" variant="outlined" :readonly="true" outlined />
                    </v-col>
                    <v-col cols="12" class="pt-6">
                        <v-select v-model="toLanguage" :items="languages" item-value="Option" item-text="Description" label="Languge" dense></v-select>
                    </v-col>
                    <v-col cols="12" class="pt-6">
                        <v-textarea v-model="new_text" :rows=10 variant="outlined" :readonly="true" outlined />
                    </v-col>
                </v-row>
                <v-divider></v-divider>
            </v-card-text>
            <v-card-actions>
                <btn_component data="" type="text" color="primary" text="Translate" tooltip="Translate the text" size="small" @actionClick="getTranslation" v-if="toLanguage!==''"/>
                <v-spacer></v-spacer>
                <btn_component data="" type="text" color="primary" text="Close" tooltip="Clase translation dialog" size="small" @actionClick="closeTranslation"/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    export default {
        components: {
            btn_component,
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                title: "Translations",
                org_text: "",
                new_text: "",
                sample: "",
                toField: "",
                toLanguage: "",
                languages: [{
                    "Option": "NL",
                    "Description": "Dutch",
                }, {
                    "Option": "EN",
                    "Description": "English",
                }, {
                    "Option": "DE",
                    "Description": "German",
                }, {
                    "Option": "FR",
                    "Description": "French",
                }, {
                    "Option": "Original",
                    "Description": "Language of question",
                }],
            }
        },
        methods: { 
            openDialog(org_text, new_text, sample, toField) {
                this.org_text = org_text;
                this.new_text = new_text;
                this.toLanguage = "";
                this.sample = sample;
                this.toField = toField;
                this.dialog = true;
            },
            getTranslation() {
                if (this.toLanguage === "Original") {
                    this.$axios.post("ares/json/ares/task/customer_success/openai/translateTextSame.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "translateTextSame"
                        },
                        translateTextSame: {
                            text: this.org_text,
                            like: this.sample,
                        }
                    }).then(res => {
                        if (res.data.error) {
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: res.data.error.message,
                                color: "error"
                            });
                        } else {
                            this.new_text = res.data.translateTextSame;
                            this.$emit("updateAction", this.toField, this.new_text);
                        }
                    });
                } else {
                    this.$axios.post("ares/json/ares/task/customer_success/openai/translateText.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "translateText"
                        },
                        translateText: {
                            text: this.org_text,
                            toLanguage: this.toLanguage,
                        }
                    }).then(res => {
                        if (res.data.error) {
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: res.data.error.message,
                                color: "error"
                            });
                        } else {
                            this.new_text = res.data.translateText;
                            this.$emit("updateAction", this.toField, this.new_text);
                        }
                    });
                }
            },
            closeTranslation() {
                this.dialog = false;
            },
        }
    }
</script>